import { FC } from 'react';

interface EmptyResultsImageProps {
    className?: string;
}

export const EmptyResultsImage: FC<EmptyResultsImageProps> = props => {
    const { className } = props;
    return (
        <svg
            width="132"
            height="115"
            viewBox="0 0 132 115"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0_13524_14193)">
                <path
                    d="M15.1197 32.9794L0.496094 103.164L54.3803 114.486L69.0039 44.3014L15.1197 32.9794Z"
                    fill="#A8D0FF"
                />
                <path
                    d="M120.25 0.0077809L65.8867 8.71484L77.1329 79.5233L131.496 70.8163L120.25 0.0077809Z"
                    fill="#A8D0FF"
                />
                <path
                    d="M99.6506 42.3595V101.081H34.7402V16.541H73.9403L99.6506 42.3595Z"
                    fill="#196CF2"
                />
                <path d="M99.6517 42.3595H73.9414V16.541L99.6517 42.3595Z" fill="#6950C3" />
                <path d="M91.6511 61.7734H42.2969V66.3383H91.6511V61.7734Z" fill="white" />
                <path d="M91.6511 73.75H42.2969V78.3149H91.6511V73.75Z" fill="white" />
                <path d="M91.6511 85.7246H42.2969V90.2895H91.6511V85.7246Z" fill="white" />
                <path
                    d="M66.0003 52.0518C66.0003 45.8862 61.0413 40.9062 54.9015 40.9062C48.7618 40.9062 43.8027 45.8862 43.8027 52.0518H66.0003Z"
                    fill="#00BFE1"
                />
                <path
                    d="M54.901 39.2158C57.9658 39.2158 60.4504 36.7208 60.4504 33.6431C60.4504 30.5653 57.9658 28.0703 54.901 28.0703C51.8361 28.0703 49.3516 30.5653 49.3516 33.6431C49.3516 36.7208 51.8361 39.2158 54.901 39.2158Z"
                    fill="#00BFE1"
                />
                <path
                    d="M99.6523 111.07C105.26 111.07 109.806 106.504 109.806 100.873C109.806 95.2411 105.26 90.6758 99.6523 90.6758C94.0442 90.6758 89.498 95.2411 89.498 100.873C89.498 106.504 94.0442 111.07 99.6523 111.07Z"
                    fill="#FFCA00"
                />
                <path
                    d="M100.714 105.971V107.631H98.6775V105.911C96.6703 105.526 95.7848 104.103 95.5781 102.651H97.6149C97.8805 103.629 98.4709 104.133 99.8878 104.133C101.039 104.133 101.629 103.718 101.629 102.977C101.629 102.236 100.921 102.147 99.1793 101.761C97.4082 101.376 95.8143 100.813 95.8143 98.8268C95.8143 97.0779 97.1131 96.07 98.648 95.744V94.084H100.655V95.7736C102.544 96.1293 103.371 97.3743 103.578 98.7971H101.511C101.305 98.0857 100.803 97.6114 99.5926 97.6114C98.3823 97.6114 97.8805 98.1153 97.8805 98.7675C97.8805 99.3603 98.3823 99.5085 99.6811 99.7753C102.338 100.339 103.696 100.931 103.696 102.917C103.725 104.874 102.19 105.763 100.714 105.971Z"
                    fill="#FF9200"
                />
                <path
                    d="M129.996 84.2724C127.133 85.3989 124.86 87.6813 123.738 90.5566C122.617 87.6813 120.344 85.3989 117.48 84.2724C120.344 83.146 122.617 80.8636 123.738 77.9883C124.86 80.8636 127.133 83.146 129.996 84.2724Z"
                    fill="#00BFE1"
                />
                <path
                    d="M23.9961 16.4209C21.1329 17.5473 18.86 19.8298 17.7383 22.7051C16.6166 19.8298 14.3437 17.5473 11.4805 16.4209C14.3437 15.2945 16.6166 13.012 17.7383 10.1367C18.86 13.012 21.1329 15.2648 23.9961 16.4209Z"
                    fill="#00BFE1"
                />
            </g>
            <defs>
                <clipPath id="clip0_13524_14193">
                    <rect width="131" height="114.51" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
